<template>
  <div class="ofs__block ofs-chart">
    <div class="ofs-chart__actions">
      <UIOrganizationChartActions :org-chart-ref hide-fields-settings :loading="!initialized" />
    </div>
    <UIOrganizationChart
      :data="chartData"
      :loading="!initialized"
      :hidden-fields="HIDDEN_FIELDS"
      :amount-formatter="analyticsStore.amountFormatter"
      @ready="orgChartRef = $event"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { forOwn, omit, pick } from 'lodash'
import { OrgChart } from '@moonwane/vue3-org-chart'

import { OrganizeFamilyStructureItem } from './utils/types'
import { AnalyticsField, AnalyticsTree } from '@types'

import { METADATA_FIELDS } from './utils/const'

import useAnalyticsStore from '@/store/analytics'

import { UIOrganizationChart, UIOrganizationChartActions } from '@ui/charts'

type Props = {
  tree: OrganizeFamilyStructureItem
  initialized: boolean
}

const props = defineProps<Props>()

const HIDDEN_FIELDS = [
  'balance',
  'thumbnail',
]

const analyticsStore = useAnalyticsStore()

const orgChartRef = ref<typeof OrgChart.prototype.data>()

const chartData = computed(() => prepareNodeForChart(props.tree))

const prepareNodeForChart = (node: OrganizeFamilyStructureItem) => {
  const nodeData = pick(node, ...METADATA_FIELDS) as AnalyticsTree
  const children = omit(node, ...METADATA_FIELDS)
  const result = []
  if (Object.keys(nodeData).length) {
    result.push(nodeData)
  } else {
    result.push({
      path: [AnalyticsField.REPO_ROOT],
      amount: 1,
      balance: 0,
    })
  }
  forOwn(children, child => {
    result.push(...prepareNodeForChart(child))
  })
  return result
}
</script>

<style>
.ofs-chart {
  @apply h-1/2;
  @apply !bg-body;
  @apply !px-2;

  &__actions {
    @apply flex items-center justify-end;
    @apply gap-2;
  }
}
</style>
